<section class="auth-modal">
	<header class="auth-modal__header">
		<div>
			<p class="auth-modal__eyebrow">{{ domainService.domain }}</p>
			<h2>{{ (isRegistering() ? 'Register' : 'Login') | translate }}</h2>
		</div>
		<button type="button" class="auth-modal__close" (click)="closeModal()" aria-label="Close login modal">
			<ion-icon name="close-outline"></ion-icon>
		</button>
	</header>

	<div class="auth-modal__body">
		@if (!isRegistering()) {
			<form class="auth-form" [formGroup]="loginForm" (ngSubmit)="login()" novalidate>
				<label class="auth-field">
					<span>{{ 'Username' | translate }}</span>
					<div class="auth-field__control" [class.is-invalid]="errorMessage() !== null || (isSubmitted() && loginForm.get('username')?.invalid)">
						<ion-icon name="person-outline"></ion-icon>
						<input
							class="login-input"
							[placeholder]="'Enter your username' | translate"
							formControlName="username"
							(input)="errorMessage.set(null); isSubmitted.set(false)"
							autocomplete="new-username"
							autocapitalize="off" />
					</div>
					@if (isSubmitted() && loginForm.get('username')?.invalid) {
						<small>{{ 'Required' | translate }}</small>
					}
				</label>

				<label class="auth-field">
					<span>{{ 'Password' | translate }}</span>
					<div class="auth-field__control" [class.is-invalid]="errorMessage() !== null || (isSubmitted() && loginForm.get('password')?.invalid)">
						<ion-icon name="lock-closed-outline"></ion-icon>
						<input
							class="login-input"
							[placeholder]="'Enter your password' | translate"
							formControlName="password"
							(input)="errorMessage.set(null); isSubmitted.set(false)"
							[attr.type]="isPasswordVisible() ? 'text' : 'password'"
							autocomplete="new-password"
							autocapitalize="off" />
						<button type="button" class="auth-field__icon-button" (click)="toggleShowPassword()" aria-label="Toggle password visibility">
							<ion-icon [attr.name]="isPasswordVisible() ? 'eye-outline' : 'eye-off-outline'"></ion-icon>
						</button>
					</div>
					@if (isSubmitted() && loginForm.get('password')?.invalid) {
						<small>{{ 'Required' | translate }}</small>
					}
				</label>

				@if (errorMessage()) {
					<p class="auth-error">{{ errorMessage() }}</p>
				}

				<ion-checkbox mode="md" labelPlacement="end" formControlName="rememberMe">
					{{ 'Remember this device' | translate }}
				</ion-checkbox>

				@if (whiteLabelService.isTurnstileEnabled()) {
					<div class="turnstile-wrapper">
						<div id="turnstile-container"></div>
					</div>
				}

				<button class="auth-submit" type="submit" [disabled]="isSubmitting()">
					{{ 'Login' | translate }}
				</button>

				@if (whiteLabelService.isSelfRegistrationEnabled()) {
					<p class="auth-switch">
						{{ "Don't have an account?" | translate }}
						<button type="button" (click)="isRegistering.set(true)">{{ 'Register now' | translate }}</button>
					</p>
				}
			</form>
		}

		@if (isRegistering()) {
			<form class="auth-form" [formGroup]="registerForm" (ngSubmit)="register()" novalidate>
				<label class="auth-field">
					<span>{{ 'Full Name' | translate }}</span>
					<div
						class="auth-field__control"
						[class.is-invalid]="registerErrorMessage() !== null || (isRegisterSubmitted() && registerForm.get('fullName')?.invalid)">
						<ion-icon name="person-outline"></ion-icon>
						<input
							class="login-input"
							[placeholder]="'Enter your full name' | translate"
							formControlName="fullName"
							(input)="registerErrorMessage.set(null); isRegisterSubmitted.set(false)"
							autocomplete="name" />
					</div>
					@if (isRegisterSubmitted() && registerForm.get('fullName')?.invalid) {
						<small>{{ 'Required' | translate }}</small>
					}
				</label>

				<label class="auth-field">
					<span>{{ 'Username' | translate }}</span>
					<div
						class="auth-field__control"
						[class.is-invalid]="registerErrorMessage() !== null || (isRegisterSubmitted() && registerForm.get('username')?.invalid)">
						<ion-icon name="person-outline"></ion-icon>
						<input
							class="login-input"
							[placeholder]="'Enter your username' | translate"
							formControlName="username"
							(input)="registerErrorMessage.set(null); isRegisterSubmitted.set(false)"
							autocomplete="new-username"
							autocapitalize="off" />
					</div>
					@if (isRegisterSubmitted() && registerForm.get('username')?.invalid) {
						<small>{{ 'Required' | translate }}</small>
					}
				</label>

				<label class="auth-field">
					<span>{{ 'Phone Number' | translate }}</span>
					<div
						class="auth-field__control"
						[class.is-invalid]="registerErrorMessage() !== null || (isRegisterSubmitted() && registerForm.get('phoneNumber')?.invalid)">
						<ion-icon name="call-outline"></ion-icon>
						<input
							type="tel"
							class="login-input"
							[placeholder]="'Phone number' | translate"
							formControlName="phoneNumber"
							(input)="registerErrorMessage.set(null); isRegisterSubmitted.set(false)"
							autocomplete="tel" />
					</div>
					@if (isRegisterSubmitted() && registerForm.get('phoneNumber')?.invalid) {
						<small>{{ 'Required' | translate }}</small>
					}
				</label>

				<label class="auth-field">
					<span>{{ 'Email (optional)' | translate }}</span>
					<div
						class="auth-field__control"
						[class.is-invalid]="registerErrorMessage() !== null || (isRegisterSubmitted() && registerForm.get('email')?.invalid)">
						<ion-icon name="mail-outline"></ion-icon>
						<input
							type="email"
							class="login-input"
							[placeholder]="'Enter your email' | translate"
							formControlName="email"
							(input)="registerErrorMessage.set(null); isRegisterSubmitted.set(false)"
							autocomplete="email"
							autocapitalize="off" />
					</div>
					@if (isRegisterSubmitted() && registerForm.get('email')?.invalid) {
						<small>{{ 'Enter a valid email' | translate }}</small>
					}
				</label>

				<label class="auth-field">
					<span>{{ 'Password' | translate }}</span>
					<div
						class="auth-field__control"
						[class.is-invalid]="registerErrorMessage() !== null || (isRegisterSubmitted() && registerForm.get('password')?.invalid)">
						<ion-icon name="lock-closed-outline"></ion-icon>
						<input
							class="login-input"
							[placeholder]="'Enter your password' | translate"
							formControlName="password"
							(input)="registerErrorMessage.set(null); isRegisterSubmitted.set(false)"
							[attr.type]="isRegisterPasswordVisible() ? 'text' : 'password'"
							autocomplete="new-password" />
						<button type="button" class="auth-field__icon-button" (click)="toggleShowRegisterPassword()" aria-label="Toggle password visibility">
							<ion-icon [attr.name]="isRegisterPasswordVisible() ? 'eye-outline' : 'eye-off-outline'"></ion-icon>
						</button>
					</div>
					@if (isRegisterSubmitted() && registerForm.get('password')?.invalid) {
						<small>{{ 'Required (min 6 chars)' | translate }}</small>
					}
				</label>

				<label class="auth-field">
					<span>{{ 'Confirm Password' | translate }}</span>
					<div
						class="auth-field__control"
						[class.is-invalid]="registerErrorMessage() !== null || (isRegisterSubmitted() && registerForm.get('confirmPassword')?.invalid)">
						<ion-icon name="lock-closed-outline"></ion-icon>
						<input
							class="login-input"
							[placeholder]="'Confirm password' | translate"
							formControlName="confirmPassword"
							(input)="registerErrorMessage.set(null); isRegisterSubmitted.set(false)"
							[attr.type]="isRegisterConfirmPasswordVisible() ? 'text' : 'password'"
							autocomplete="new-password" />
						<button
							type="button"
							class="auth-field__icon-button"
							(click)="toggleShowRegisterConfirmPassword()"
							aria-label="Toggle password visibility">
							<ion-icon [attr.name]="isRegisterConfirmPasswordVisible() ? 'eye-outline' : 'eye-off-outline'"></ion-icon>
						</button>
					</div>
					@if (isRegisterSubmitted() && registerForm.get('confirmPassword')?.invalid) {
						<small>{{ 'Required' | translate }}</small>
					}
				</label>

				@if (registerErrorMessage()) {
					<p class="auth-error">{{ registerErrorMessage() }}</p>
				}

				<ion-checkbox mode="md" labelPlacement="end" formControlName="rememberMe">
					{{ 'Remember this device' | translate }}
				</ion-checkbox>

				<button class="auth-submit" type="submit" [disabled]="isRegisterSubmitting()">
					{{ 'Register' | translate }}
				</button>

				<p class="auth-switch">
					<button type="button" (click)="isRegistering.set(false)">{{ 'Back to login' | translate }}</button>
				</p>
			</form>
		}
	</div>
</section>
